import clsx from 'clsx';
import { NextParsedUrlQuery } from 'next/dist/server/request-meta';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ReactElement } from 'react';

import { Typography } from '@/shared/components/atoms';

import LeftArrow from '~/images/shared/leftArrow.svg';

export default function Breadcrumbs({
  subHeader,
}: {
  subHeader?: string;
}): ReactElement {
  const { t } = useTranslation(['common', 'navigation']);
  const router = useRouter();

  // get pathes and delete empty strings or dynamic routing [id]
  const newPaths: {
    path: string;
    name: string | string[] | undefined;
    query?: NextParsedUrlQuery;
  }[] = [];

  router.pathname.split('/').map((path, idx) => {
    path === ''
      ? false
      : path === '[id]' ||
        path === '[workerId]' ||
        path === '[name]' ||
        path === '[field]'
      ? newPaths.push({
          path:
            path === '[id]'
              ? router.query.id?.toString() || ''
              : path === '[workerId]'
              ? router.query.workerId?.toString() || ''
              : path === '[name]'
              ? router.query.name?.toString() || ''
              : path === '[field]'
              ? router.query.field?.toString() || ''
              : '',
          name: router.query[`idIdendifier_${idx}`],
          query: {
            [`idIdendifier_${idx}`]: router.query[`idIdendifier_${idx}`],
          },
        })
      : newPaths.push({
          path: path,
          name: path,
        });
  });

  //  if route is home page
  if (newPaths.length === 0) {
    newPaths.push({ path: 'home', name: 'home' });
  }

  const breadcrumbs = newPaths.map(({ path, name, query }, index) => {
    const isLast = index === newPaths.length - 1;
    const tempPth = newPaths.slice(0, index + 1);
    const routeTo = `/${tempPth
      .map((item) => encodeURIComponent(item.path))
      .join('/')}`;

    return {
      routeTo,
      isLast,
      name: name ? t(name, { ns: ['common', 'navigation'] }) : path,
      query,
    };
  });

  // if in the first stage of path not nested
  if (breadcrumbs.length === 1) {
    return (
      <div>
        <Typography variant='h2' weight='bold'>
          {breadcrumbs[0].name}
        </Typography>
        {subHeader && (
          <Typography className='mt-8 text-grey-600'>{subHeader}</Typography>
        )}
      </div>
    );
  }
  // if nested paths
  return (
    <div className='flex items-center ' aria-label='Breadcrumb'>
      {breadcrumbs.map(({ routeTo, name, isLast, query }) => {
        const keys = Object.keys({ ...query });
        const values = Object.values({ ...query });
        const newQuery = keys.map((key, idx) => {
          return `${key}=${encodeURIComponent((values[idx] as string) || '')}`;
        });
        let newRoute = `${routeTo}${query ? '?' + newQuery.join('&') : ''}`;
        newRoute = newRoute.replaceAll(' ', '+');

        return (
          <div key={name} className='flex items-center '>
            {isLast ? (
              <Typography
                variant='body2'
                weight='semiBold'
                className={clsx(
                  'cursor-pointer',
                  isLast
                    ? 'pointer-events-none text-text-600'
                    : 'text-primary-default'
                )}
              >
                {name}
              </Typography>
            ) : // TODO: find a better solution !!!!
            newRoute === '/accounts' ? (
              <>
                <Typography
                  variant='body2'
                  weight='semiBold'
                  className={clsx(
                    'cursor-pointer',
                    isLast
                      ? 'pointer-events-none text-text-600'
                      : 'text-primary-default'
                  )}
                >
                  {name}
                </Typography>
                <LeftArrow className='mx-12 text-10 ltr:rotate-180' />
              </>
            ) : (
              <>
                <Link prefetch={false} href={`/${newRoute}`}>
                  <Typography
                    variant='body2'
                    weight='semiBold'
                    className={clsx(
                      'cursor-pointer',
                      isLast
                        ? 'pointer-events-none text-text-600'
                        : 'text-primary-default'
                    )}
                  >
                    {name}
                  </Typography>
                </Link>
                <LeftArrow className='mx-12 text-10 ltr:rotate-180' />
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
